var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-6"},[_c('span',{staticClass:"text-xl font-principal-medium"},[_vm._v(" Contenu de la mission ")]),(_vm.module.sequences && _vm.module.sequences.length > 0)?_c('div',{staticClass:"mt-4"},[_c('MissionSequenceForm',{attrs:{"sequence":_vm.module.sequences[0]},on:{"update-sequence":_vm.updateSequenceData}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }